var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.183221 1.16381C0.509698 0.454466 1.21916 0 2.00003 0H38C38.7809 0 39.4904 0.454466 39.8168 1.16381C40.1433 1.87316 40.0271 2.70764 39.5192 3.30079L25.6 19.557V34C25.6 34.6914 25.2429 35.3338 24.6557 35.6987C24.0685 36.0636 23.3344 36.0994 22.7145 35.7933L15.5145 32.2377C14.832 31.9007 14.4 31.2056 14.4 30.4444V19.557L0.480835 3.30079C-0.0270384 2.70764 -0.143256 1.87316 0.183221 1.16381ZM6.34548 4L17.9192 17.517C18.2295 17.8794 18.4 18.3407 18.4 18.8178V29.2015L21.6 30.7818V18.8178C21.6 18.3407 21.7706 17.8794 22.0808 17.517L33.6546 4H6.34548Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.183221 1.16381C0.509698 0.454466 1.21916 0 2.00003 0H38C38.7809 0 39.4904 0.454466 39.8168 1.16381C40.1433 1.87316 40.0271 2.70764 39.5192 3.30079L25.6 19.557V34C25.6 34.6914 25.2429 35.3338 24.6557 35.6987C24.0685 36.0636 23.3344 36.0994 22.7145 35.7933L15.5145 32.2377C14.832 31.9007 14.4 31.2056 14.4 30.4444V19.557L0.480835 3.30079C-0.0270384 2.70764 -0.143256 1.87316 0.183221 1.16381ZM6.34548 4L17.9192 17.517C18.2295 17.8794 18.4 18.3407 18.4 18.8178V29.2015L21.6 30.7818V18.8178C21.6 18.3407 21.7706 17.8794 22.0808 17.517L33.6546 4H6.34548Z",
    fill: "url(#paint0_linear_1403_10982)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_10982",
    x1: 40.0001,
    y1: 9,
    x2: -1.86265e-7,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E8FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#79C389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#F2BC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5543"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/no-data-icon.4b686744e742af05f69fa49ad1850549.svg";
export { ForwardRef as ReactComponent };